import { BuildingRegion } from './building-region';
import { ReservationDailyRule } from './reservation-daily-rule';

import { Utils } from '../helpers/utils';

export class Reservation {
	id: number;
	company_id: number;

	reservation_daily_rule_id: number;
	building_region_id: number;

	reservation_daily_rule: ReservationDailyRule;
	building_region: BuildingRegion;

	schedule: string;
	customer_name: string;
	customer_phone: string;
	people_qty: number;

	customer_description: string; // description added by customer, such as 'wedding aniversary'
	company_description: string; // description added by employee 'table 10. romantic decoration'

	additional_info: string; // used by ncommerce system

	status: 'pending'|'accepted'|'confirmed'|'rejected'|'cancelled';

	reservation_token: string; // so that the customer can access reservation status

	created_at: string;
	updated_at: string;

	// given by our server
	building_region_name: string;

	// set by front end app
	probability: 'none'|'low'|'high'; // probability of being accepted
	statusPtbr: 'pendente'|'aceita'|'confirmada'|'rejeitada'|'cancelada';
	hourMinute: string;
	dayOfWeek: string;
	companyName: string;
	expand: boolean;

	static setAdditionalData(res: Reservation, rdrs: ReservationDailyRule[] = []) {
		switch(res.status) {
			case "pending": {
				res.statusPtbr = 'pendente';
				break;
			}
			case "accepted": {
				res.statusPtbr = 'aceita';
				break;
			}
			case "confirmed": {
				res.statusPtbr = 'confirmada';
				break;
			}
			case "rejected": {
				res.statusPtbr = 'rejeitada';
				break;
			}
			case "cancelled": {
				res.statusPtbr = 'cancelada';
				break;
			}
		}
		let aux = Utils.dateToISO(res.schedule, false);
		let time = aux.split(" ")[1].split(":");
		time.pop();
		res.hourMinute = time.join(":");

		for(let rdr of rdrs) {
			if(res.reservation_daily_rule_id == rdr.id) {
				ReservationDailyRule.setAdditionalData(rdr);
				res.reservation_daily_rule = rdr;
				break;
			}
		}
	}

	static setArrayAdditionalData(ress: Reservation[]) {
		for(let res of ress) {
			Reservation.setAdditionalData(res);
		}
	}
}